import { render } from "./Overview.vue?vue&type=template&id=4ebec656"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/player/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ebec656"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ebec656', __exports__)) {
    api.reload('4ebec656', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=4ebec656", () => {
    api.rerender('4ebec656', render)
  })

}


export default __exports__